<template>
  <section 
    class="mt-2" 
    v-if="rfq && (estimationHasWall || estimationHasRailing)">

    <template v-if="hasCostBreakdown">
      <h1>Cost and Benefit Breakdown</h1>

      <div class="content--nobreak" v-if="estimationHasWall">
        <h2>
          Solar Cladding Cost Breakdown (Total and per SQFT)
        </h2>
        <tax-incentives
          :estimation="estimation"
          :has-mpa-price="hasMpaPrice"
          :has-dpa-price="hasDpaPrice"/>
      </div>

      <div class="content--nobreak" v-if="estimationHasRailing">
        <h2>
          Solar Railing Cost Breakdown (Total and per LF)
        </h2>
        <tax-incentives
          :estimation="estimation"
          :has-mpa-price="hasMpaPrice"
          :has-dpa-price="hasDpaPrice"
          rail-or-wall="rail"/>
      </div>
    </template>

    <div class="mb-3" v-if="costBreakdownOne" v-html="costBreakdownOne">
    </div>

    <div v-if="costBreakdownTwo" v-html="costBreakdownTwo">
    </div>

    <div v-if="hasTaxIncentiveSummary" class="content--nobreak">
      <template v-if="hasMpaPrice">
        <h2>
          Summary of Possible Tax Incentives Under MPA
        </h2>
        <possible-tax-incentives
          :estimation="estimation"
          :has-mpa-price="true"
          :has-dpa-price="false"/>
      </template>

      <template v-if="hasDpaPrice">
        <h2>
          Summary of Possible Tax Incentives Under DPA
        </h2>
        <possible-tax-incentives
          :estimation="estimation"
          :has-mpa-price="false"
          :has-dpa-price="true"/>
      </template>

      <div class="mb-3" v-if="taxIncentiveDesc" v-html="taxIncentiveDesc">
      </div>

      <div class="mb-3" v-if="summaryTaxIncentiveDesc" v-html="summaryTaxIncentiveDesc">
      </div>

      <div class="help">
        Please Note: The above calculations are the results of our research into 
        the facts as understood by us. It should be used by the client to 
        independently make decisions and should not be considered conclusion, 
        decision, or report.
      </div>
    </div>
    
  </section>
</template>

<script>
import TaxIncentives from '@/components/proposalmaker/TaxIncentives'
import PossibleTaxIncentives from '@/components/proposalmaker/PossibleTaxIncentives'

export default {
  props: {
    hasCostBreakdown: {
      type: Boolean,
      default: true
    },
    hasTaxIncentiveSummary: {
      type: Boolean,
      default: true
    },
    costBreakdownOne: {
      type: [String, Number],
      default: null
    },
    costBreakdownTwo: {
      type: [String, Number],
      default: null
    },
    taxIncentiveDesc: {
      type: [String, Number],
      default: null
    },
    summaryTaxIncentiveDesc: {
      type: [String, Number],
      default: null
    },
    rfq: {
      type: Object
    },
    hasMpaPrice: {
      type: Boolean
    },
    hasDpaPrice: {
      type: Boolean
    }
  },
  components: { TaxIncentives, PossibleTaxIncentives },
  computed: {
    estimation({ rfq }) {
      return rfq.c_estimation ? rfq.c_estimation : rfq.estimation;
    },
    estimationHasWall({ estimation }) {
      return Object.keys(estimation.estimation_summary).includes('solar_wall_active');
    },
    estimationHasRailing({ estimation }) {
      return estimation.estimation_summary.summary.filter(
        d => d.pricing_summary.includes('railing')
      ).length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
</style>
